module.exports = __webpack_public_path__ + "img/Quality.e0297ab9.jpeg";